var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Vue, Component, Watch } from 'vue-property-decorator';
import Main from './components/Main.vue';
import QuickNav from './components/QuickNav.vue';
import { isApp } from '@/common/utils/ways';
import { loadFinish } from '@lhb/bridge';
import { debounce, urlParams } from '@lhb/func';
import { setCookie } from '@/common/utils/tools';
import { getHeader } from 'src/common/request/utils';
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.issafariBrowser = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
        _this.transitionName = 'slide-left';
        _this.defaultTransitionName = []; // 不需要动画的页面
        _this.isDev = process.env.NODE_ENV === 'development';
        return _this;
    }
    // watch
    Layout.prototype.routeHandler = function (to, from) {
        var isBack = this.$store.getters.getIsBack;
        if (this.defaultTransitionName.includes(to.name)) {
            this.transitionName = '';
        }
        else if (isBack ||
            (to.meta &&
                to.meta.keepAliveTo &&
                to.meta.keepAliveTo.includes(from.name))) {
            this.transitionName = 'slide-left';
        }
        else {
            this.transitionName = 'slide-right';
        }
    };
    Object.defineProperty(Layout.prototype, "showQuickNav", {
        // computed
        get: function () {
            var isEmptyPath = location.pathname === '/';
            return this.isDev && isEmptyPath;
        },
        enumerable: false,
        configurable: true
    });
    // 通过url携带token、tenantId、employeeId参数时，写入cookie（目前是钉钉环境下移动端跳转的场景）
    Layout.prototype.created = function () {
        // 不要使用this.$route.query
        // const { token, tenantId, employeeId } = this.$route.query;
        var _a = urlParams(location.search), token = _a.token, tenantId = _a.tenantId, employeeId = _a.employeeId;
        if (token) {
            setCookie('flow_token', token);
            tenantId && setCookie('TENANT_ID', tenantId);
            employeeId && setCookie('EMPLOYEE_ID', employeeId);
        }
        this.init();
    };
    Layout.prototype.mounted = function () {
        // console.log('issafariBrowser', this.issafariBrowser);
        // console.log('navigator.userAgent', navigator.userAgent, /Safari/.test(navigator.userAgent), !/Chrome/.test(navigator.userAgent));
        if (isApp()) {
            setTimeout(function () {
                loadFinish();
            }, 100);
        }
        // 强制刷新根元素的font-size(三方应用内，偶发性的rem失效)
        window.addEventListener('resize', debounce(function () {
            var screenWidth = window.screen.width;
            var docFontSize = screenWidth / 10;
            docFontSize && (document.documentElement.style.fontSize = docFontSize + "px");
        }, 150));
    };
    Layout.prototype.init = function () {
        this.initGetTenantCheckInfo();
    };
    /** 检查是否有 token */
    Layout.prototype.checkHasToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            var config;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, getHeader()];
                    case 1:
                        config = _a.sent();
                        return [2 /*return*/, !!config.token];
                }
            });
        });
    };
    /** 初始化立即获取一次当前租户的检查信息（含拓店模板） */
    Layout.prototype.initGetTenantCheckInfo = function () {
        return __awaiter(this, void 0, void 0, function () {
            var pathname, ignoreRoute, needRequestRoute, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        pathname = location.pathname;
                        ignoreRoute = [
                            '/share/youth',
                            '/',
                        ];
                        if (ignoreRoute.includes(pathname)) {
                            return [2 /*return*/];
                        }
                        needRequestRoute = [
                            /\/approval\/?.*/,
                            /\/standardstore\/?.*/,
                        ];
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        if (!needRequestRoute.some(function (item) { return item.test(pathname); })) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.checkHasToken()];
                    case 2:
                        // 有 token 才请求接口；防止某些页面不需要请求
                        if (_a.sent()) {
                            this.$store.dispatch('getTaskTemplateCode');
                        }
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_1 = _a.sent();
                        console.log('error', error_1);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    __decorate([
        Watch('$route')
    ], Layout.prototype, "routeHandler", null);
    Layout = __decorate([
        Component({
            components: {
                Main: Main,
                QuickNav: QuickNav
            },
        })
    ], Layout);
    return Layout;
}(Vue));
export default Layout;
